import clsx from "clsx";

export function MarkReadBtn({
  read,
  className,
  iconClassName,
}: {
  read: VoidFunction;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <button
      type="button"
      onClick={read}
      className={clsx(
        "flex items-center justify-evenly rounded-lg px-2 py-1.5 hover:drop-shadow-sm group",
        className
      )}
    >
      <span
        className={clsx(
          "w-4 h-4 icon-[eva--done-all-outline] mr-1 flex-shrink-0",
          iconClassName
        )}
      />
      <span className="text-xs whitespace-nowrap text-inherit">Mark read</span>
    </button>
  );
}
